module.exports = __webpack_public_path__ + "static/media/dollar_icon.71d7d9f1.svg";